type TimeSlot = { startHour: number; endHour: number };
type DaySchedule = { dayOfWeek: number; slots: TimeSlot[] };

// EU hotline / chat schedule (Europe/Vienna = CET/CEST)
// Mon, Tue, Thu, Fri: 9am–6pm
// Wednesday: 9am–12pm & 2pm–6pm
const EU_SCHEDULE: DaySchedule[] = [
  { dayOfWeek: 1, slots: [{ startHour: 9, endHour: 18 }] }, // Monday
  { dayOfWeek: 2, slots: [{ startHour: 9, endHour: 18 }] }, // Tuesday
  { dayOfWeek: 3, slots: [{ startHour: 9, endHour: 12 }, { startHour: 14, endHour: 18 }] }, // Wednesday
  { dayOfWeek: 4, slots: [{ startHour: 9, endHour: 18 }] }, // Thursday
  { dayOfWeek: 5, slots: [{ startHour: 9, endHour: 18 }] }, // Friday
];

// US hotline schedule (America/Los_Angeles = PST/PDT)
// Mon–Fri: 9am–6pm PT
const US_SCHEDULE: DaySchedule[] = [
  { dayOfWeek: 1, slots: [{ startHour: 9, endHour: 18 }] }, // Monday
  { dayOfWeek: 2, slots: [{ startHour: 9, endHour: 18 }] }, // Tuesday
  { dayOfWeek: 3, slots: [{ startHour: 9, endHour: 18 }] }, // Wednesday
  { dayOfWeek: 4, slots: [{ startHour: 9, endHour: 18 }] }, // Thursday
  { dayOfWeek: 5, slots: [{ startHour: 9, endHour: 18 }] }, // Friday
];

const WEEKDAY_SHORT: Record<string, number> = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
};

function getLocalParts(timezone: string, now: Date): { dayOfWeek: number; hour: number } {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    weekday: 'short',
    hour: 'numeric',
    hour12: false,
  }).formatToParts(now);

  const weekdayStr = parts.find((p) => p.type === 'weekday')?.value ?? '';
  const hourStr = parts.find((p) => p.type === 'hour')?.value ?? '0';

  return {
    dayOfWeek: WEEKDAY_SHORT[weekdayStr] ?? -1,
    // Guard against '24' returned for midnight by some V8 versions
    hour: Number.parseInt(hourStr, 10) % 24,
  };
}

export function isSupportAvailable(country: string = 'at', now: Date = new Date()): boolean {
  const isUS = country === 'us';
  const timezone = isUS ? 'America/Los_Angeles' : 'Europe/Vienna';
  const schedule = isUS ? US_SCHEDULE : EU_SCHEDULE;

  const { dayOfWeek, hour } = getLocalParts(timezone, now);

  const daySchedule = schedule.find((d) => d.dayOfWeek === dayOfWeek);
  if (!daySchedule) {
    return false;
  }

  return daySchedule.slots.some((slot) => hour >= slot.startHour && hour < slot.endHour);
}
